import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Background = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  background-color: ${BaSeTheme.colors.defaultColors.black};

  &::before {
    position: absolute;
    content: '';
    width: 100vw;
    height: 100vh;
    display: block;
    top: 0;
    right: 0;
    background: radial-gradient(
      circle at top right,
      ${({ gradientColor }) => gradientColor} -10vw,
      transparent 40vw
    );
  }
`;
